<template>
  <BaseSelect v-model="selected">
    <template #selected>
      <div
        v-if="selected"
        class="text-left break-words whitespace-pre-wrap"
        style="line-height: 115%;"
      >
        {{ options.find((i) => i.value === selected)?.label || '&nbsp;' }}
      </div>
      <div
        v-else
        class="text-left break-words whitespace-pre-wrap text-gray-400"
        style="line-height: 115%;"
      >
        {{ placeholder }}
      </div>
    </template>
    <template #options>
      <BaseSelectOption
        v-for="(option, index) in required ? options : [undefined, ...options]"
        :key="index"
        :value="option?.value"
      >
        {{ option?.label || '&nbsp;' }}
      </BaseSelectOption>
    </template>
  </BaseSelect>
</template>

<script lang="ts">
import { useVModel } from '@vueuse/core';
import { defineComponent, PropType } from 'vue';

import { OptionItem } from '@/models/option_item';

import BaseSelect from './BaseSelect.vue';
import BaseSelectOption from './BaseSelectOption.vue';

export default defineComponent({
  name: 'SurveyInputSelect',
  components: {
    BaseSelect,
    BaseSelectOption,
  },
  props: {

    /**
     * 選択肢
     */
    options: {
      type: Array as PropType<OptionItem[]>,
      default: () => ([]),
    },

    /**
     *  選択されている値
     */
    modelValue: {
      type: String,
      default: undefined,
    },

    /**
     * プレースホルダ
     */
    placeholder: {
      type: String,
      default: '入力してください',
    },

    /**
     * 必須かどうか
     */
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(props, { emit }) {
    const selected = useVModel(props, 'modelValue', emit);
    return {
      selected,
    };
  },
});
</script>
